import { render, staticRenderFns } from "./IndustryReport.vue?vue&type=template&id=5b2327f1&scoped=true"
import script from "./IndustryReport.vue?vue&type=script&lang=ts"
export * from "./IndustryReport.vue?vue&type=script&lang=ts"
import style0 from "./IndustryReport.vue?vue&type=style&index=0&id=5b2327f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2327f1",
  null
  
)

export default component.exports